import { useMemo } from 'react';

function validate(val) {
  if (val === null) {
    return false;
  }
  if (val === undefined) {
    return false;
  }
  return true;
}

const labels = {
  elected: {
    true: 'Elected',
    false: 'Not-elected'
  }
};

export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id }
}) {
  const options = useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      const value = row.values[id];
      if (validate(value) && !options.has(value)) {
        options.add(value);
      }
    });

    return [...options.values()];
  }, [id, preFilteredRows]);
  const useLabels = Object.keys(labels).includes(id);
  return (
    <div style={{ padding: '0.5rem 0' }}>
      <select
        style={{
          border: '1px solid #999',
          height: '2.2rem',
          fontSize: '1rem',
          width: '100%'
        }}
        value={filterValue || ''}
        size='small'
        onChange={(e) => setFilter(e.target.value.split(','))}
      >
        <option value=''>All</option>
        {useLabels &&
          options.map((option, i) => (
            <option key={i} value={option}>
              {labels[id][option]}
            </option>
          ))}
        {!useLabels &&
          options.map((option, i) => (
            <option key={i} value={option}>
              {option}
            </option>
          ))}
      </select>
    </div>
  );
}

export function parseGroupedRows(rows) {
  return rows.flatMap((row) =>
    row.hasOwnProperty('leafRows')
      ? row.leafRows.map((leafRow) => leafRow.original)
      : row.original
  );
}
